import api from 'api';

export const loadDrillTo = api('POST /api/tracker/table/drillTo');
export const loadDimensions = api('POST /api/tracker/table/dimensions');
export const loadTable = api('POST /api/tracker/table');
export const loadTableExpand = api('POST /api/tracker/table/expand');
export const exportTable = api('POST /api/tracker/table/csv', {
  responseType: 'blob',
});

export const requestMail = api('POST /api/profile/subscriptions/mail');

export const exportFromGoogleDrive = api(
  'POST /api/tracker/table/export-to-google-drive'
);
